// extracted by css-extract-rspack-plugin
export default {"wrapper":"TrafficLight-module__wrapper--fGqou"};